import { useRef } from 'react';
import { Button } from '@music-vine/cadence/ui';
import { GlobalSearch, type GlobalSearchHandle } from '@/features/GlobalSearch/globalSearch';
import { useRouter } from 'next/router';
import { cn } from '@/lib/utils';
import { usesHomepageNav } from '@/utils/page-chrome';
export const TopBarContentSearchButton = () => {
  // Create a ref to the GlobalSearch component to access its methods
  const globalSearchRef = useRef<GlobalSearchHandle>(null);
  const router = useRouter();
  const hidesSearchButton = usesHomepageNav(router.pathname);
  return <>
      {/* Hidden GlobalSearch component to access its functionality */}
      <div className="hidden">
        <GlobalSearch ref={globalSearchRef} data-sentry-element="GlobalSearch" data-sentry-source-file="TopBarContentSearchButton.tsx" />
      </div>

      <Button aria-label="Open global search" borderRadius="full" className={cn('mobile-search-button flex md:hidden', hidesSearchButton && 'hidden')} data-testid="mobile-search-button" onClick={() => {
      if (globalSearchRef.current) {
        globalSearchRef.current.openSearch();
      }
    }} size="icon" variant="transparent" data-sentry-element="Button" data-sentry-source-file="TopBarContentSearchButton.tsx">
        <svg className="fill-current" fill="none" height="14" role="presentation" viewBox="0 0 17 16" width="14" xmlns="http://www.w3.org/2000/svg" data-sentry-element="svg" data-sentry-source-file="TopBarContentSearchButton.tsx">
          <path clipRule="evenodd" d="M16.5981 7.00023C16.5981 10.8658 13.4644 13.9995 9.59879 13.9995C8.02659 13.9995 6.57547 13.4811 5.407 12.606L2.30656 15.7064C1.91607 16.0969 1.28296 16.0969 0.892476 15.7064C0.501987 15.3159 0.501987 14.6828 0.892476 14.2923L3.99291 11.192C3.11778 10.0235 2.59943 8.5724 2.59943 7.00023C2.59943 3.13465 5.73315 0.000976562 9.59879 0.000976562C13.4644 0.000976562 16.5981 3.13465 16.5981 7.00023ZM14.5983 7.00023C14.5983 9.76136 12.36 11.9997 9.59879 11.9997C6.83762 11.9997 4.59924 9.76136 4.59924 7.00023C4.59924 4.2391 6.83762 2.00076 9.59879 2.00076C12.36 2.00076 14.5983 4.2391 14.5983 7.00023Z" fillRule="evenodd" data-sentry-element="path" data-sentry-source-file="TopBarContentSearchButton.tsx" />
        </svg>
      </Button>
    </>;
};